import React, { useRef, useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import CSSModules from 'react-css-modules'
import ClientLoginLayout from 'spa/client/layouts/ClientLoginLayout'
import { API } from 'javascripts/api'
import styles from './style.module.scss'

const ClientStaffPassword: React.FC = () => {
  const passwordRef = useRef<HTMLInputElement>(null)
  const passwordConfirmationRef = useRef<HTMLInputElement>(null)
  const [passwordError, setPasswordError] = useState<string | null>(null)
  const [passwordConfirmationError, setPasswordConfirmationError] = useState<string | null>(null)
  const { accessToken } = useParams<{ accessToken: string }>()
  const navigate = useNavigate()

  useEffect(() => {
    let alive = true

    API.verifyClientStaffToken(accessToken).then(() => {
      /* DO NOTHING */
    }).catch(() => {
      if (alive) navigateSignup()
    })

    return () => { alive = false }
  }, [])

  const navigateSignup = () => {
    navigate('/client_auth/signup', {
      state: {
        flash: { alert: 'リンクの有効期限が切れています。メールアドレスの認証をしてください。' }
      }
    })
  }

  const handleSubmit: React.FormEventHandler = (event) => {
    event.preventDefault()

    const params = {
      password: passwordRef.current.value,
      passwordConfirmation: passwordConfirmationRef.current.value,
    }

    API.updateClientStaffPassword(accessToken, params).then((response) => {
      navigate('/client_auth/login', {
        state: {
          flash: { success: response.data.message }
        }
      })

      return response
    }).catch(error => {
      if (API.isAxiosError(error)) {
        if (API.isNotFoundError(error.response)) {
          navigateSignup()
        }
        else if (API.isBadRequestError(error.response) && error.response.data.operationId === 'updateClientStaffPassword') {
          const { errors } = error.response.data
          setPasswordError(errors.password ? errors.password.join('') : null)
          setPasswordConfirmationError(errors.passwordConfirmation ? errors.passwordConfirmation.join('') : null)
        }
      }
    })
  }

  return (
    <ClientLoginLayout>
      <div styleName='client-staff-password'>
        <div styleName='client-staff-password-inner'>
          <h1>パスワード設定</h1>
          <form onSubmit={handleSubmit}>
            <div styleName='form-item'>
              <label styleName='form-item-label' htmlFor='input-password'>パスワード</label>
              <div styleName='form-item-inner'>
                <div styleName='form-item-content'>
                  <input
                    type='password'
                    id='input-password'
                    className={passwordError ? '-error' : ''}
                    ref={passwordRef}
                  />
                </div>
                {passwordError ? <div styleName='form-item-error'>{passwordError}</div> : null}
              </div>
            </div>
            <div styleName='form-item'>
              <label styleName='form-item-label' htmlFor='input-password-confirmation'>パスワード（確認）</label>
              <div styleName='form-item-inner'>
                <div styleName='form-item-content'>
                  <input
                    type='password'
                    id='input-password-confirmation'
                    className={passwordConfirmationError ? '-error' : ''}
                    ref={passwordConfirmationRef}
                  />
                </div>
                {passwordConfirmationError ? <div styleName='form-item-error'>{passwordConfirmationError}</div> : null}
              </div>
            </div>
            <div styleName='form-item'>
              <div styleName='form-item-inner'>
                <div styleName='form-item-content'>
                  <input type='submit' value='設定する' />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </ClientLoginLayout>
  )
}

export default CSSModules<React.FC>(ClientStaffPassword, styles)
